import { render, staticRenderFns } from "./RemoveUserModal.vue?vue&type=template&id=7c4038d6"
import script from "./RemoveUserModal.vue?vue&type=script&lang=js"
export * from "./RemoveUserModal.vue?vue&type=script&lang=js"
import style0 from "./RemoveUserModal.vue?vue&type=style&index=0&id=7c4038d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports